import { Breakpoints } from '../enums'

export interface IBreakpoints<T> {
  [Breakpoints.xxs]: T
  [Breakpoints.xs]: T
  [Breakpoints.sm]: T
  [Breakpoints.md]: T
  [Breakpoints.lg]: T
}

export interface DeviceWidth {
  above: IBreakpoints<boolean>
}
